import {FC} from 'react'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useHoteleria} from '../../../../hooks/useHoteleria'
import ContainerWrapper from '../../../central/pages/componentes/Container'
import {ResizeHandle} from '../../components/Layout/Container/ResizeHandle/ResizeHandle'
import {ListComponentsHoteleria} from '../../components/components'

const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListComponentsHoteleria[key]
  }
  return component
}
const ReportSubPageWrapper: FC = () => {
  const {currentTabItem} = useHoteleria()
  return (
    <ContainerWrapper>
      <PanelGroup autoSaveId='example' direction='vertical'>
        <Panel
          collapsible={true}
          order={1}
          key={`panel-hoteleria-header-${currentTabItem.title}`}
          id={`panel-hoteleria-header-${currentTabItem.title}`}
          className={'panel__box'}
        >
          {renderPanelContent(currentTabItem.content.headerPanel)}
        </Panel>
        {currentTabItem.showPanel && (
          <>
            <ResizeHandle />
            <Panel
              className={'panel__box'}
              collapsible={true}
              defaultSize={50}
              order={2}
              key={`panel-hoteleria-detail-${currentTabItem.title}`}
              id={`panel-hoteleria-detail-${currentTabItem.title}`}
            >
              {renderPanelContent(currentTabItem.content.detailPanel)}
            </Panel>
          </>
        )}
      </PanelGroup>
    </ContainerWrapper>
  )
}

export {ReportSubPageWrapper}
